import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts-more';
HighchartsMore(Highcharts);

class GraphView extends Component {
  constructor(props, context) {
    super(props, context);
    this._component = null;
  }

  componentDidMount() {
    if (this.props.modules) {
      this.props.modules.forEach(function (module) {
        module(Highcharts);
      });
    }
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  makeChart(props, component) {
    this.chart = new Highcharts[props.type || "Chart"](
      component = ReactDOM.findDOMNode(this),
      props.options
    );
  }

  setNMake(component) {
    this.makeChart(this.props, component);
  }

  render() {
    return (
      <div style={this.props.style}>
        <div ref={(c) => c ? this.setNMake(c) : null}>
        </div>
      </div>
    );
  }
}

export default GraphView;



// WEBPACK FOOTER //
// ./src/components/GraphView.js